import type { CSSProperties } from 'react'
import { Logo } from '../Logo/Logo'
import './PrizeWheel.css'

export interface PrizeWheelProps {
  prizes: string[]
  colors?: string[]
  size?: number
}

const DEFAULT_COLORS = ['#e86f51', '#264653', '#f5a361', '#1c343e']

/** Decorative spinning prize wheel for seasonal games (e.g. "Roue Estivale"). */
export function PrizeWheel({ prizes, colors = DEFAULT_COLORS, size = 320 }: PrizeWheelProps) {
  const segment = 360 / prizes.length
  const gradient = `conic-gradient(${prizes
    .map((_, i) => `${colors[i % colors.length]} ${i * segment}deg ${(i + 1) * segment}deg`)
    .join(', ')})`

  return (
    <div className="azoya-prize-wheel" style={{ '--azoya-pw-size': `${size}px` } as CSSProperties}>
      <div className="azoya-prize-wheel-pointer" />
      <div className="azoya-prize-wheel-ring" />
      <div className="azoya-prize-wheel-disc" style={{ background: gradient }}>
        {prizes.map((label, i) => (
          <div
            className="azoya-prize-wheel-prize"
            style={{ transform: `rotate(${i * segment + segment / 2}deg)` }}
            key={label}
          >
            <span>{label}</span>
          </div>
        ))}
      </div>
      <div className="azoya-prize-wheel-hub">
        <Logo size={Math.round(size * 0.14)} />
      </div>
    </div>
  )
}
